import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../images/logo.png'
import logofooter from '../images/logo-f.png'
import {FaLinkedin} from 'react-icons/fa'
import {FaFacebookF} from 'react-icons/fa'
import {AiFillInstagram} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'


const Footer = () => {
  return (
 
    <footer>
        <div className=" footer__container">
            <article>
                <Link to="/"><img src={logofooter} alt="FooterLogo" /></Link>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora asperiores tenetur vitae ab, consectetur praesentium laudantium nemo vel iusto perspiciatis?</p>
                <div className="footer__socials">
                    <a href="https://www.linkedin.com/in/vishwakarmasumit/" target="_blank" rel='noreferrer noopener'> <FaLinkedin/></a>
                    <a href="https://www.facebook.com/profile.php?id=100011098114610" target="_blank" rel='noreferrer noopener'> <FaFacebookF/></a>
                    <a href="https://twitter.com/Devil_staar" target="_blank" rel='noreferrer noopener'><AiOutlineTwitter/></a>
                    <a href="https://www.instagram.com/sumit._vishwakarma/" target="_blank" rel='noreferrer noopener'><AiFillInstagram/></a>
                </div>
            </article>
            <article>
                <h4>Permalinks</h4>
                <hr/>
                <Link to='/about'>About</Link>
                <Link to='/plans'>Plans</Link>
                <Link to='/trainers'>Trainers</Link>
                <Link to='/gallery'>Gallery</Link>
                <Link to='/contact'>Contact</Link>
            </article>
            <article>
                <h4>Insights</h4>
                <hr/>
                <Link to='/s'>Blog</Link>
                <Link to='/s'>Case Studies</Link>
                <Link to='/s'>Events</Link>
                <Link to='/s'>Communities</Link>
                <Link to='/s'>FAQs</Link>
            </article>
            <article>
                <h4>Get In Touch</h4>
                <hr/>
                <Link to='/contact'>Contact</Link>
                <Link to='/s'>Support</Link>
               
            </article>
        </div>

        <div className="footer__copyright">
            <small>2022 WebTechWithSumit &copy; All Right Reserved</small>
        </div>
    </footer>
  )
}

export default Footer